import {
  CURATOR_OWNER_NONCOMMERCIAL,
  FEATURED_SET_EVENT,
} from 'app/shared/utils/events';

interface EventForCalculateEventFee {
  eventOrganizedAs: string;
  competition?: {
    id?: number;
  };
  type?: string;
  serviceFee?: number;
  bookingFee: number | null;
}

interface EventAttendeeForCalculateEventFee {
  source?: string;
}

/** Calculates the event fee that is applied at checkout */
export const calculateEventFee = (
  event: EventForCalculateEventFee | null,
  eventAttendee: EventAttendeeForCalculateEventFee | null
) => {
  if (!event || event.eventOrganizedAs === CURATOR_OWNER_NONCOMMERCIAL) {
    return 0;
  }

  const attendeeIsCompetitionWinner =
    eventAttendee && eventAttendee.source === 'competition';
  const eventIsCompetition = event?.competition?.id;

  if (eventIsCompetition && attendeeIsCompetitionWinner) {
    return 0;
  }

  const isFeaturedSetEvent = event.type === FEATURED_SET_EVENT;
  const serviceFee = event.serviceFee ? event.serviceFee / 100 : 0;
  const bookingFee = event.bookingFee ? event.bookingFee / 100 : 0;

  return isFeaturedSetEvent ? serviceFee : bookingFee;
};
